<template>
  <div class="launch-btn">
    <template v-if="isWeixin">
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_5565e835b0c6"
        :path="queryPath"
        @error="onError"
      >
        <script type="text/wxtag-template">
          <style>.btn { outline: none;border: none;font-weight: 700;font-size: 17px;color: #06ae56;background-color: #f2f2f2;width: 184px;padding: 8px 24px;line-height: 1.41176471;border-radius: 4px; }</style>
          <button class="btn">{{label}}</button>
        </script>
      </wx-open-launch-weapp>
    </template>
    <template v-else>
      <a :href="link" v-if="link" class="weui-btn weui-btn_default" style="width:auto">{{
        label
      }}</a>
    </template>
  </div>
</template>

<script>
import weixin from "@/mixins/weixin";
import Finger from "@/util/finger.js";

export default {
  mixins: [weixin],
  props: {
    label: {
      type: String,
      default: "打开小程序",
    },
    path: {
      type: String,
      default: 'pages/login/login'
    },
    query: String
  },
  data() {
    return {
      isWeixin: this.isWeixinClient() && !this.isWxWorkClient(),
      link: null,
    };
  },
  computed: {
    queryPath() {
      return this.path + (this.query ? ('?' + this.query) : '');
    }
  },
  created() {
    if (!this.isWeixin) {
      // 外部环境，通过scheme码跳转
      this.getSchemeLink();
    }
  },
  methods: {
    onError(e) {
      this.$weui.topTips(e.detail, 3000);
    },
    getSchemeLink() {
      var me = this;
      this.$ajax({
        url: "/api/miniprogram/scheme/generate",
        params: {
          program: "qyq",
          path: me.path,
          query: me.query,
          clientId: Finger.get()
        },
      }).then(function (res) {
        if (res.data) {
          me.link = res.data;
          // 尝试直接跳转，有些浏览器会阻拦
          window.location.href = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.launch-btn {
  margin: 20px 40px;
  text-align: center;
}
</style>